document.addEventListener("DOMContentLoaded", (e) => {
  getCartLabels();
  document.addEventListener("cart:created", (event) => {
    getCartLabels();
  });
});

async function getCartLabels() {
  let htmlJSON = await fetch(
    window.Shopify.routes.root + "?sections=ajax-labels"
  );
  if (!htmlJSON.ok) {
    console.error("Error fetching Cart Labels");
    return;
  }
  let JSONSection = await htmlJSON.json();
  let tempDiv = document.createElement("div");
  tempDiv.innerHTML = JSONSection["ajax-labels"];

  let labelProducts = document.querySelectorAll("[data-add-label]");
  labelProducts.forEach((item) => {
    if (!item.querySelector("product-label")) {
      let tempLabels = tempDiv.querySelector(
        `[data-id="${item.getAttribute("data-id")}"] product-labels`
      );
      if (tempLabels) {
        item.appendChild(tempLabels);
      }
    }
  });
}
